import React, {
	useState,
	useCallback,
	useEffect,
	Suspense,
	useRef,
} from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LoadingSpinner from './shared/components/UIElements/LoadingSpinner'
import Home from './shared/components/Navigation/Home.js'
import UpdateAllTeamJerseyNumbers from './admin/components/UpdateAllTeamJerseyNumbers.js'
import Teams from './teams/pages/Teams.js'
import BrandNewPlayerFormForUnfounds from './players/pages/BrandNewPlayerFormForUnfounds.js'
import RosterAndSchedulePage from './players/components/RosterAndSchedulePage.js'
import Leaders from './leaders/pages/Leaders.js'
import StatsAndStandingsHome from './shared/components/Navigation/StatsAndStandingsHome.js'
import ScoringLeadersHome from './shared/components/Navigation/ScoringLeadersHome.js'
import SchedulesHome from './shared/components/Navigation/SchedulesHome.js'
import Standings from './standings/pages/Standings.js'
import AdminTournaments from './admin/components/AdminTournaments.js'
import AdminPage from './admin/pages/AdminPage.js'
import AdminHowTo from './admin/components/AdminHowTo.js'
import AdminVideoList from './admin/components/AdminVideoList.js'
import { AuthContext } from './shared/context/auth-context'
import LoginPage from './admin/pages/LoginPage.js'
import AdminTeamList from './admin/components/AdminTeamList.js'
import AdminDivisionList from './admin/components/AdminDivisionList.js'
import AdminVenueList from './admin/components/AdminVenueList.js'
import AdminPlayersOnTeamList from './admin/components/AdminPlayersOnTeamList.js'
import AdminArchivedLeagueList from './admin/components/AdminArchivedLeagueList.js'
import PlayerHistory from './players/components/PlayerHistory.js'
import AdminAllPlayersInSystemList from './admin/components/AdminAllPlayersInSystemList.js'
import AdminMasterSchedule from './admin/components/AdminMasterSchedule.js'
import AdminMasterScheduleWeek from './admin/components/AdminMasterScheduleWeek'
import LeagueSchedule from './shared/schedule/LeagueSchedule.js'
import TeamSchedule from './shared/schedule/TeamSchedule.js'
import VenueSchedule from './shared/schedule/VenueSchedule'
import DivisionSchedule from './shared/schedule/DivisionSchedule.js'
import AdminGameResults from './admin/components/AdminGameResults.js'
import AdminGameResults2 from './admin/components/AdminGameResults2.js'
import AdminGameResultsPlayoff from './admin/components/AdminGameResultsPlayoff.js'
import AdminGameResultsPlayoff2 from './admin/components/AdminGameResultsPlayoff2.js'
import AdminGameResultsChampionship from './admin/components/AdminGameResultsChampionship'
import AdminScoresheet from './admin/components/AdminScoresheet'
import TeamSchedulesHome from './shared/components/Navigation/TeamSchedulesHome'
import AdminVenueSchedule from './admin/components/AdminVenueSchedule'
import AdminLeagueSchedule from './admin/components/AdminLeagueSchedule'
import PreviousLeagues from './league/pages/PreviousLeagues'
import GameSummaryHome from './shared/components/Navigation/GameSummaryHome'
import AdminPersonnelList from './admin/components/AdminPersonnelList'
import TournamentScoringLeaders from './teams/pages/TournamentScoringLeaders.js'
import AdminUploadTeam from './admin/components/AdminUploadTeam.js'
import PlayerPhotoForm from './players/pages/PlayerPhotoForm.js'
import PlayerPhotoFormFromAllPlayers from './players/pages/PlayerPhotoFormFromAllPlayers.js'
import PlayerStatsHome from './shared/components/Navigation/PlayerStatsHome.js'
import TeamPhotoForm from './teams/pages/TeamPhotoForm.js'
import PlayerMerge from './admin/components/PlayerMerge.js'
import AppDownloadGate from './shared/components/UIElements/AppDownloadGate.js'
//
// lazy loading...
const NewTeamForm = React.lazy(() => import('./teams/pages/NewTeamForm.js'))
const NewDivisionForm = React.lazy(
	() => import('./teams/pages/NewDivisionForm.js'),
)
const NewLeagueForm = React.lazy(
	() => import('./league/pages/NewLeagueForm.js'),
)
const NewVenueForm = React.lazy(
	() => import('./shared/schedule/NewVenueForm.js'),
)
const NewTournamentForm = React.lazy(
	() => import('./shared/schedule/NewTournamentForm.js'),
)
const NewPersonnelForm = React.lazy(
	() => import('./shared/schedule/NewPersonnelForm.js'),
)
const NewPlayerOnTeamForm = React.lazy(
	() => import('./players/pages/NewPlayerOnTeamForm.js'),
)
const UpdateLeagueForm = React.lazy(
	() => import('./league/pages/UpdateLeagueForm.js'),
)
const NewVideoForm = React.lazy(
	() => import('./shared/schedule/NewVideoForm.js'),
)
const UpdateVideoForm = React.lazy(
	() => import('./shared/schedule/UpdateVideoForm.js'),
)
const UpdateVenueForm = React.lazy(
	() => import('./shared/schedule/UpdateVenueForm.js'),
)
const UpdateTournamentForm = React.lazy(
	() => import('./shared/schedule/UpdateTournamentForm.js'),
)
const UpdatePersonnelForm = React.lazy(
	() => import('./shared/schedule/UpdatePersonnelForm.js'),
)
const UpdateDivisionForm = React.lazy(
	() => import('./teams/pages/UpdateDivisionForm.js'),
)
const UpdateTeamForm = React.lazy(
	() => import('./teams/pages/UpdateTeamForm.js'),
)
const UpdatePlayerForm = React.lazy(
	() => import('./players/pages/UpdatePlayerForm.js'),
)
const AddGamesForm = React.lazy(() => import('./admin/games/AddGamesForm.js'))
const BrandNewPlayerForm = React.lazy(
	() => import('./players/pages/BrandNewPlayerForm.js'),
)
const ChangePlayerNumberForm = React.lazy(
	() => import('./players/pages/ChangePlayerNumberForm.js'),
)
const AddEventsForm = React.lazy(() => import('./admin/games/AddEventsForm.js'))
const UpdateGameForm = React.lazy(
	() => import('./admin/games/UpdateGameForm.js'),
)
const UpdateEventForm = React.lazy(
	() => import('./admin/games/UpdateEventForm.js'),
)

const AppOnlyGate = ({ children }) => {
	const [isChecking, setIsChecking] = useState(true)
	const [inApp, setInApp] = useState(false)

	useEffect(() => {
		const timer = setTimeout(() => {
			const app =
				typeof window !== 'undefined' &&
				(!!window.executeWhenAppReady ||
					!!window.makeInAppPurchase ||
					!!window.restorePurchases)

			setInApp(app)
			setIsChecking(false)
		}, 750)

		return () => clearTimeout(timer)
	}, [])

	if (isChecking) {
		return (
			<div className='center'>
				<LoadingSpinner />
			</div>
		)
	}

	if (!inApp) {
		return <AppDownloadGate />
	}

	return children
}

//let logoutTimer

//const INACTIVITY_LIMIT = 10 * 1000 // 10 seconds (for testing purposes)
const INACTIVITY_LIMIT = 2 * 60 * 60 * 1000 // 2 hours in ms

function App() {
	//Matt:  all this authorization logic stuff, Max ended up putting in a different
	//file called auth-hook.js.  This was optional.  I'm not doing that.  I'm just
	//keeping all that logic in here.
	const [token, setToken] = useState()
	//const [tokenExpirationDate, setTokenExpirationDate] = useState()
	const [isLoggedIn, setIsLoggedIn] = useState(false)

	const inactivityTimerRef = useRef(null)
	//****************************************************************** */
	//
	//    login
	//
	//
	//****************************************************************** */
	const login = useCallback((token) => {
		setIsLoggedIn(true)
		setToken(token)
		const now = Date.now()

		localStorage.setItem(
			'userData',
			JSON.stringify({
				token: token,
			}),
		)
		// track last activity time
		localStorage.setItem('lastActivity', String(now))
	}, [])
	//****************************************************************** */
	//
	//    logout
	//
	//
	//****************************************************************** */
	const logout = useCallback(() => {
		console.log('inside logout within App.js')
		setIsLoggedIn(false)
		setToken(null)
		localStorage.removeItem('userData')
		localStorage.removeItem('lastActivity')
	}, [])

	//****************************************************************** */
	//
	//   ON APP START: check localStorage
	//   - If token exists AND lastActivity is recent -> restore login
	//   - Else -> force logout (clears stale data)
	//
	//****************************************************************** */
	useEffect(() => {
		const storedData = JSON.parse(localStorage.getItem('userData'))
		const lastActivityStr = localStorage.getItem('lastActivity')
		const lastActivity = lastActivityStr ? parseInt(lastActivityStr, 10) : 0
		const now = Date.now()

		if (
			storedData &&
			storedData.token &&
			lastActivity &&
			now - lastActivity < INACTIVITY_LIMIT
		) {
			// still within inactivity window → restore login
			setIsLoggedIn(true)
			setToken(storedData.token)
		} else {
			// no token, no lastActivity, or too much time has passed → force logout
			logout()
		}
	}, [logout])

	//****************************************************************** */
	//
	//    Auto-logout after INACTIVITY_LIMIT of *inactivity*
	//
	//****************************************************************** */
	useEffect(() => {
		// Only track inactivity if logged in (i.e., we have a token)
		if (!token) {
			if (inactivityTimerRef.current) {
				clearTimeout(inactivityTimerRef.current)
				inactivityTimerRef.current = null
			}
			return
		}

		const events = [
			'mousemove',
			'mousedown',
			'keypress',
			'touchstart',
			'scroll',
			'click',
		]

		const recordActivityAndResetTimer = () => {
			const now = Date.now()
			localStorage.setItem('lastActivity', String(now))

			if (inactivityTimerRef.current) {
				clearTimeout(inactivityTimerRef.current)
			}

			inactivityTimerRef.current = setTimeout(() => {
				const lastStr = localStorage.getItem('lastActivity')
				const last = lastStr ? parseInt(lastStr, 10) : 0
				const diff = Date.now() - last

				if (!last || diff >= INACTIVITY_LIMIT) {
					console.log('Logging out due to inactivity (timer)...')
					logout()
					window.location.href = '/admin/login'
				}
			}, INACTIVITY_LIMIT)
		}

		// Start timer immediately when logged in / token changes
		recordActivityAndResetTimer()

		// Reset timer & update lastActivity on user activity
		events.forEach((eventName) =>
			window.addEventListener(eventName, recordActivityAndResetTimer),
		)

		// Optional: handle coming back from background without full reload
		const handleVisibilityChange = () => {
			if (!document.hidden) {
				const lastStr = localStorage.getItem('lastActivity')
				const last = lastStr ? parseInt(lastStr, 10) : 0
				const diff = Date.now() - last

				if (last && diff >= INACTIVITY_LIMIT) {
					console.log('Logging out due to inactivity (on resume)...')
					logout()
					window.location.href = '/admin/login'
				} else {
					recordActivityAndResetTimer()
				}
			}
		}

		document.addEventListener('visibilitychange', handleVisibilityChange)

		// Cleanup on unmount or token change
		return () => {
			events.forEach((eventName) =>
				window.removeEventListener(eventName, recordActivityAndResetTimer),
			)
			document.removeEventListener('visibilitychange', handleVisibilityChange)

			if (inactivityTimerRef.current) {
				clearTimeout(inactivityTimerRef.current)
			}
		}
	}, [token, logout])

	let routes

	if (isLoggedIn) {
		routes = (
			<React.Fragment>
				<Routes>
					<Route exact path='/' element={<Home />}></Route>
					<Route
						exact
						path='/admin/leagues/current'
						element={<AdminPage />}
					></Route>
					<Route
						path='/admin/:leagueName/:year/:divisionId/:teamName/updateAllJerseyNumbers'
						element={<UpdateAllTeamJerseyNumbers />}
					/>
					<Route
						exact
						path='/admin/playerMerge'
						element={<PlayerMerge />}
					></Route>
					<Route exact path='/admin/howto' element={<AdminHowTo />}></Route>
					<Route
						exact
						path='/admin/tournaments'
						element={<AdminTournaments />}
					></Route>
					<Route
						exact
						path='/admin/:playerId/playerPhoto'
						element={<PlayerPhotoForm />}
					></Route>
					<Route
						exact
						path='/admin/:playerId/playerPhotoAllPlayers'
						element={<PlayerPhotoFormFromAllPlayers />}
					></Route>
					<Route
						exact
						path='/statsandstandings'
						// element={<StatsAndStandingsHome />}
						element={<Standings />}
					></Route>
					<Route
						exact
						path='/scoringleaders'
						element={<ScoringLeadersHome />}
					></Route>
					<Route
						exact
						path='/playerStats'
						element={<PlayerStatsHome />}
					></Route>
					<Route
						exact
						path='/gameSummary/:gameId'
						element={<GameSummaryHome />}
					></Route>
					<Route exact path='/schedule' element={<SchedulesHome />}></Route>
					<Route exact path='/league/:leagueId' element={<Teams />}></Route>
					<Route
						exact
						path='/league/scoring/:leagueId'
						element={<TournamentScoringLeaders />}
					></Route>
					<Route
						exact
						path='/league/:leagueId/scoringLeaders'
						element={<Leaders />}
					></Route>
					{/* <Route exact path='/scoringLeaders' element={<Leaders />}></Route> */}
					<Route
						exact
						path='/scoringLeaders'
						element={<TournamentScoringLeaders />}
					></Route>
					<Route
						exact
						path='/league/:leagueId/standings'
						element={<Standings />}
					></Route>
					<Route
						exact
						path='/league/previousLeagues'
						element={<PreviousLeagues />}
					></Route>
					<Route
						exact
						path='/league/:leagueId/:divisionName/:year/:teamName'
						element={<RosterAndSchedulePage />}
					></Route>
					<Route
						exact
						path='/league/schedule/:leagueId'
						element={<LeagueSchedule />}
					></Route>
					<Route
						exact
						path='/league/teamSchedule/:teamId'
						element={<TeamSchedule />}
					></Route>
					<Route
						exact
						path='/league/schedule/:leagueName/:teamId/:year/:teamName'
						element={<TeamSchedule />}
					></Route>
					<Route
						exact
						path='/admin/:venueId/schedule'
						element={<AdminVenueSchedule />}
					></Route>
					<Route
						exact
						path='/schedule/admin/:leagueId'
						element={<AdminLeagueSchedule />}
					></Route>
					<Route
						exact
						path='/league/:venueId/schedule'
						element={<VenueSchedule />}
					></Route>
					<Route
						exact
						path='/league/:divisionName/:leagueId/:divisionId/schedule'
						element={<DivisionSchedule />}
					></Route>
					<Route
						exact
						path='/league/schedule/:leagueName/:divisionName/:year/:teamName'
						element={<TeamSchedulesHome />}
					></Route>
					<Route
						exact
						path='/admin/league/new'
						element={<NewLeagueForm />}
					></Route>
					<Route
						exact
						path='/admin/venue/new'
						element={<NewVenueForm />}
					></Route>
					<Route
						exact
						path='/admin/video/new'
						element={<NewVideoForm />}
					></Route>
					<Route
						exact
						path='/admin/tournaments/new'
						element={<NewTournamentForm />}
					></Route>
					<Route
						exact
						path='/admin/personnel/new'
						element={<NewPersonnelForm />}
					></Route>
					<Route
						exact
						path='/admin/leagues/archive'
						element={<AdminArchivedLeagueList />}
					></Route>
					<Route
						exact
						path='/admin/updateLeague/:leagueId'
						element={<UpdateLeagueForm />}
					></Route>
					<Route
						exact
						path='/admin/updateVenue/:venueId'
						element={<UpdateVenueForm />}
					></Route>
					<Route
						exact
						path='/admin/updateVideo/:videoId'
						element={<UpdateVideoForm />}
					></Route>
					<Route
						exact
						path='/admin/updateTournament/:tournamentId'
						element={<UpdateTournamentForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:session/:year/newTeam'
						element={<NewTeamForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:divisionName/:session/:year/newTeam'
						element={<NewTeamForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:year/newDivision'
						element={<NewDivisionForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:divisionName/:year/newDivision'
						element={<NewDivisionForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:year/updateDivision/:divisionId'
						element={<UpdateDivisionForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:year/:divisionId/updateTeam/:teamId'
						element={<UpdateTeamForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:session/:year/updateTeamWithDivision/:teamId'
						element={<UpdateTeamForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:divisionId/:year/:teamName/:playerId/changeNumber'
						element={<ChangePlayerNumberForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:year/:divisionId/teams'
						element={<AdminTeamList />}
					></Route>
					{/* <Route
						exact
						path='/admin/:leagueName/:divisionName/:session/:year/teams'
						element={<AdminTeamList />}
					></Route> */}
					<Route
						exact
						path='/admin/:leagueName/:year/divisions'
						element={<AdminDivisionList />}
					></Route>
					<Route
						exact
						path='/admin/masterSchedule'
						element={<AdminMasterSchedule />}
					></Route>
					<Route
						exact
						path='/admin/masterScheduleWeek'
						element={<AdminMasterScheduleWeek />}
					></Route>
					<Route
						exact
						path='/admin/venues'
						element={<AdminVenueList />}
					></Route>
					<Route
						exact
						path='/admin/allVideos'
						element={<AdminVideoList />}
					></Route>
					<Route
						exact
						path='/admin/personnel'
						element={<AdminPersonnelList />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:year/:divisionId/:teamName/players'
						element={<AdminPlayersOnTeamList />}
					></Route>
					<Route
						exact
						path='/admin/:teamId/:teamName/:year/:leagueName/:divisionId/uploadTeam'
						element={<AdminUploadTeam />}
					></Route>
					<Route
						exact
						path='/admin/newPlayer'
						element={<BrandNewPlayerForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:year/:divisionId/:teamName/:teamId/newPlayerFromUnfounds'
						element={<BrandNewPlayerFormForUnfounds />}
					></Route>
					<Route
						exact
						path='/admin/getAllPlayers'
						element={<AdminAllPlayersInSystemList />}
					></Route>
					<Route
						exact
						path='/admin/updatePlayer/:playerId'
						element={<UpdatePlayerForm />}
					></Route>
					<Route
						exact
						path='/admin/updatePersonnel/:personnelId'
						element={<UpdatePersonnelForm />}
					></Route>
					<Route
						exact
						path='/admin/updateGame/:gameId'
						element={<UpdateGameForm />}
					></Route>
					<Route
						exact
						path='/admin/updateEvent/:gameId'
						element={<UpdateEventForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:divisionId/:year/:teamName/addPlayers'
						element={<NewPlayerOnTeamForm />}
					></Route>
					<Route
						exact
						path='/admin/:leagueName/:divisionName/:session/:year/:teamName/addPlayers'
						element={<NewPlayerOnTeamForm />}
					></Route>
					<Route exact path='/games/new' element={<AddGamesForm />}></Route>
					<Route
						exact
						path='/admin/events/new'
						element={<AddEventsForm />}
					></Route>
					<Route
						exact
						path='/admin/gameResults/:gameId'
						element={<AdminGameResults />}
					></Route>
					<Route
						exact
						path='/admin/gameResults2/:gameId'
						element={<AdminGameResults2 />}
					></Route>
					<Route
						exact
						path='/admin/playoffGameResults2/:gameId'
						element={<AdminGameResultsPlayoff2 />}
					></Route>
					<Route
						exact
						path='/admin/playoffGameResults/:gameId'
						element={<AdminGameResultsPlayoff />}
					></Route>
					<Route
						exact
						path='/admin/championshipGameResults/:gameId'
						element={<AdminGameResultsChampionship />}
					></Route>
					<Route
						exact
						path='/admin/scoresheet/:gameId'
						element={<AdminScoresheet />}
					></Route>
					<Route
						exact
						path='/admin/:teamId/teamPhoto'
						element={<TeamPhotoForm />}
					></Route>
					<Route
						exact
						path='/:playerId/history'
						element={<PlayerHistory />}
					></Route>
				</Routes>
			</React.Fragment>
		)
	} else {
		routes = (
			<React.Fragment>
				<Routes>
					{/* <Route exact path='/' element={<Home />}></Route> */}
					<Route exact path='/' element={<StatsAndStandingsHome />}></Route>
					<Route exact path='/admin/login' element={<LoginPage />}></Route>
					<Route
						exact
						path='/statsandstandings'
						// element={<StatsAndStandingsHome />}
						element={<Standings />}
					></Route>
					<Route
						exact
						path='/scoringleaders'
						element={<ScoringLeadersHome />}
					></Route>
					<Route
						exact
						path='/playerStats'
						element={<PlayerStatsHome />}
					></Route>
					<Route
						exact
						path='/gameSummary/:gameId'
						element={<GameSummaryHome />}
					></Route>
					<Route exact path='/schedule' element={<SchedulesHome />}></Route>
					<Route exact path='/league/:leagueId' element={<Teams />}></Route>
					<Route
						exact
						path='/league/scoring/:leagueId'
						element={<TournamentScoringLeaders />}
					></Route>
					<Route
						exact
						path='/league/:leagueId/:divisionName/:year/:teamName'
						element={<RosterAndSchedulePage />}
					></Route>
					<Route
						exact
						path='/league/previousLeagues'
						element={<PreviousLeagues />}
					></Route>
					<Route
						exact
						path='/league/:leagueId/scoringLeaders'
						element={<Leaders />}
					></Route>
					{/* <Route exact path='/scoringLeaders' element={<Leaders />}></Route> */}
					<Route
						exact
						path='/scoringLeaders'
						element={<TournamentScoringLeaders />}
					></Route>
					<Route
						exact
						path='/league/leagues/:leagueId/standings'
						element={<Standings />}
					></Route>
					<Route
						exact
						path='/league/schedule/:leagueId'
						element={<LeagueSchedule />}
					></Route>
					<Route
						exact
						path='/league/teamSchedule/:teamId'
						element={<TeamSchedule />}
					></Route>
					<Route
						exact
						path='/league/:venueId/schedule'
						element={<VenueSchedule />}
					></Route>
					<Route
						exact
						path='/league/:divisionName/:leagueId/:divisionId/schedule'
						element={<DivisionSchedule />}
					></Route>
					<Route
						exact
						path='/league/schedule/:leagueName/:teamId/:year/:teamName'
						element={<TeamSchedule />}
					></Route>
					<Route
						exact
						path='/:playerId/history'
						element={
							<AppOnlyGate>
								<PlayerHistory />
							</AppOnlyGate>
						}
					></Route>
				</Routes>
			</React.Fragment>
		)
	}

	//not sure if I want to include a redirect here?  Watch end of Max video 40 if i decide to
	return (
		<AuthContext.Provider
			value={{
				isLoggedIn: !!token,
				token: token,
				login: login,
				logout: logout,
			}}
		>
			<Router>
				{/* <Routes> */}
				<Suspense
					fallback={
						<div className='center'>
							<LoadingSpinner />
						</div>
					}
				>
					{routes}
				</Suspense>
				{/* </Routes> */}
			</Router>
		</AuthContext.Provider>
	)
}

export default App
